import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";

export const blockMasterColumnsObj = {
	block_code: {
		name: "Block Code",
		key: "block_code",
		input_type: inputTypes.AUTO_GENERATE.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	brand: {
		name: "Brand",
		key: "brand",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	section: {
		name: "Section",
		key: "section",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	department: {
		name: "Category",
		key: "department",
		input_type: inputTypes.SELECT.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	block_name: {
		name: "Block Name",
		key: "block_name",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	size: {
		name: "Size",
		key: "size",
		data_type: datatypes.STRING.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	chest: {
		name: "Chest (inches)",
		key: "chest",
		data_type: datatypes.NUMBER.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	garment_length: {
		name: "Garment Length (inches)",
		key: "garment_length",
		data_type: datatypes.NUMBER.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	shoulder: {
		name: "Shoulder (inches)",
		key: "shoulder",
		data_type: datatypes.NUMBER.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
	sleeve_length: {
		name: "Sleeve Length (inches)",
		key: "sleeve_length",
		data_type: datatypes.NUMBER.key,
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true },
	},
};
